"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = _interopRequireDefault(require("@tippy.js/react"));

require("tippy.js/dist/tippy.css");

require("tippy.js/animations/shift-toward.css");

var _propTypes = require("prop-types");

var _energyUi = require("@widergy/energy-ui");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UTTooltip = /*#__PURE__*/function (_Component) {
  _inherits(UTTooltip, _Component);

  function UTTooltip() {
    _classCallCheck(this, UTTooltip);

    return _possibleConstructorReturn(this, _getPrototypeOf(UTTooltip).apply(this, arguments));
  }

  _createClass(UTTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content,
          stringContentProps = _this$props.stringContentProps,
          stringContentClassName = _this$props.stringContentClassName,
          _this$props$hideOnCli = _this$props.hideOnClick,
          hideOnClick = _this$props$hideOnCli === void 0 ? false : _this$props$hideOnCli,
          _this$props$arrow = _this$props.arrow,
          arrow = _this$props$arrow === void 0 ? true : _this$props$arrow,
          _this$props$duration = _this$props.duration,
          duration = _this$props$duration === void 0 ? [600, 350] : _this$props$duration,
          _this$props$inertia = _this$props.inertia,
          inertia = _this$props$inertia === void 0 ? true : _this$props$inertia,
          tippyProps = _this$props.tippyProps,
          _this$props$interacti = _this$props.interactive,
          interactive = _this$props$interacti === void 0 ? true : _this$props$interacti,
          className = _this$props.className;
      if (!content) return children;
      return _react["default"].createElement(_react2["default"], _extends({
        animation: "shift-toward",
        inertia: inertia,
        duration: duration,
        arrow: arrow,
        hideOnClick: hideOnClick,
        className: className,
        interactive: interactive
      }, tippyProps, {
        content: _react["default"].isValidElement(content) ? content : _react["default"].createElement(_energyUi.UTLabel, _extends({}, stringContentProps, {
          className: "".concat(_stylesModule["default"].baseContent, " ").concat(stringContentClassName)
        }), content)
      }), children);
    }
  }]);

  return UTTooltip;
}(_react.Component);

UTTooltip.propTypes = {
  placement: _propTypes.string,
  className: _propTypes.string,
  icon: _propTypes.element,
  content: _propTypes.node,
  hideOnClick: _propTypes.bool,
  arrow: _propTypes.bool,
  duration: (0, _propTypes.arrayOf)(_propTypes.number),
  inertia: _propTypes.bool,
  interactive: _propTypes.bool,
  stringContentClassName: _propTypes.string,
  stringContentProps: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  tippyProps: _propTypes.any // eslint-disable-line react/forbid-prop-types

};
var _default = UTTooltip;
exports["default"] = _default;